/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_Method_Bia_ResearchInputs */

const en_us2_body_assessment_reference_method_bia_research = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research-grade bioimpedance`)
};

const pt_br2_body_assessment_reference_method_bia_research = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedância de pesquisa`)
};

const es_419_body_assessment_reference_method_bia_research = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedancia de investigación`)
};

const pt_pt2_body_assessment_reference_method_bia_research = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedância de investigação`)
};

const fr_fr2_body_assessment_reference_method_bia_research = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impédancemétrie de recherche`)
};

const de_de2_body_assessment_reference_method_bia_research = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedanz in Forschungsqualität`)
};

const it_it2_body_assessment_reference_method_bia_research = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedenza da ricerca`)
};

/**
* | output |
* | --- |
* | "Research-grade bioimpedance" |
*
* @param {Body_Assessment_Reference_Method_Bia_ResearchInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_method_bia_research = /** @type {((inputs?: Body_Assessment_Reference_Method_Bia_ResearchInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_Method_Bia_ResearchInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_method_bia_research(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_method_bia_research(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_method_bia_research(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_method_bia_research(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_method_bia_research(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_method_bia_research(inputs)
	return en_us2_body_assessment_reference_method_bia_research(inputs)
});
export { body_assessment_reference_method_bia_research as "body-assessment.reference_method.bia_research" }